export const apiRoutes = {
    status: '',
    auth: {
        google_login: 'auth/google',
        me: 'auth/me'
    },
    ask: '/guruji/ask',
    joinNewsletter: '/api/newsletter/subscribe',
    sendQuote: '/api/quote/submit'
}

export function getBearerTokenFormat(tk) {
    return `Bearer ${tk}`;
}